<template>
  <div class="head-page">
    <Header :title="$t('transfer.title')" :iconurl="'transfer-list'" :icontype="2" :iconkey="'todo-list-o'" />
    <div class="head-page-overflow">
      <div class="transfer-box">
        <div style="margin-bottom: 15px">
          <van-field
            v-if="!usr"
            class="tmp"
            v-model="searchval"
            center
            clearable
            :placeholder="$t('transfer.searchtxt')"
          >
            <template #button>
              <van-button
                @click="toSearch"
                size="small"
                class="web-btn-rise"
                icon="search"
              />
            </template>
          </van-field>
          <div v-else style="margin-top: 16px" @click="resetSearch">
            <van-icon name="arrow-left" size="18" />{{ $t("common.back") }}
          </div>
        </div>
        <div v-if="usr">
          <div class="title">
            {{ $t("transfer.ReceivingAccount") }}
          </div>
          <div
            class="confrim-box"
            :class="ischeck ? 'box-up' : 'box-down'"
            @click="ischeck = true"
          >
            <div style="margin-right: 8px">
              <van-icon
                v-if="!ischeck"
                name="warning-o"
                class="data-down"
                size="28"
              />
              <van-icon v-else name="passed" class="data-up" size="28" />
            </div>
            <div class="account-info">
              {{ $t("transfer.toaccount") }} : {{ usr.username }}
            </div>
          </div>
          <div v-if="!ischeck" class="tip data-down">
            {{ $t("transfer.confirmtxt") }}
          </div>
          <div v-else class="tip data-up">
            {{ $t("transfer.confirmedtxt") }}
          </div>
        </div>
      </div>
      <div class="transfer-box" v-if="usr && ischeck">
        <div class="title">{{ $t("transfer.numtxt") }}</div>
        <van-form @submit="onSubmit">
          <div>
            <van-row class="frm-box">
              <van-col :span="6">
                <div
                  style="height: 44px; line-height: 44px; padding-left: 18px"
                  @click="showPicker = true"
                >
                  {{ usrbalance.title }} <van-icon name="arrow-down" />
                </div>
              </van-col>
              <van-col :span="18">
                <van-field
                  class="tmp"
                  type="number"
                  v-model="num"
                  :placeholder="$t('transfer.numerror')"
                  :rules="[
                    {
                      required: true,
                    },
                  ]"
                >
                  <template #button>
                    <span class="link-btn" @click="num = usrbalance.balance">{{
                      $t("common.all")
                    }}</span>
                  </template>
                </van-field>
              </van-col>
            </van-row>
          </div>
          <div v-if="safeWapConfig.traders_password_switch == 1">
            <van-field
              :label="$t('withdrawal.frmtitle2')"
              class="tmp"
              v-model="pwd"
              type="password"
              :placeholder="$t('withdrawal.frmplaceholder2')"
              :rules="[
                {
                  required: true,
                },
              ]"
            >
            </van-field>
          </div>

          <p class="tip">
            {{ $t("trade.used") }} :
            {{ parseFloat(usrbalance.balance).toFixed(8) }}
            {{ usrbalance.title }}
          </p>
          <van-row style="line-height: 2.4">
            <van-col :span="8">{{ $t("withdrawal.fee") }}</van-col>
            <van-col :span="16" class="txt-right"
              ><span v-if="usrbalance.internal_transfer_sxf == 0">{{
                $t("transfer.fee")
              }}</span>
              <span v-else>
                {{ parseFloat(usrbalance.internal_transfer_sxf) * 100 }} %</span
              >
            </van-col>
            <van-col :span="8">{{ $t("transfer.ArrivalTime") }}</van-col>
            <van-col :span="16" class="txt-right">
              <span v-if="usrbalance.internal_transfer_days == 0"
                >{{ $t("transfer.Immediately") }}
              </span>
              <span v-else>
                {{ usrbalance.internal_transfer_days }} {{ $t("common.day") }}
              </span>
            </van-col>
            <van-col :span="24" class="txt-center">
              {{ $t("transfer.realnum") }}
              <p style="line-height: 1; font-size: 20px; font-weight: 700">
                {{
                  num
                    ? usrbalance.internal_transfer_sxf != 0
                      ? (
                          parseFloat(num) -
                          parseFloat(num) *
                            parseFloat(usrbalance.internal_transfer_sxf)
                        ).toFixed(8)
                      : num
                    : 0
                }}
                {{ usrbalance.title }}
              </p>
            </van-col>
          </van-row>
          <div style="margin: 30px 16px 16px">
            <van-button native-type="submit" class="web-btn">
              <van-loading v-if="posting" /><span v-else>{{
                $t("transfer.btn")
              }}</span></van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="transferCoin"
        value-key="title"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "MemberTransfer",
  components: { Header },
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      ischeck: false,
      searchval: null,
      usr: null,
      transferCoin: null,
      showPicker: false,
      usrbalance: {},
      num: null,
      pwd: null,
      posting:false
    };
  },
  mounted() {
    this.getTransferCoin();
  },
  methods: {
    async getTransferCoin() {
      await this.$http({
        method: "post",
        url: "getTransferCoin",
        data: { username: this.searchval },
      }).then((res) => {
        this.transferCoin = res.data;
        if (this.transferCoin && this.transferCoin.length > 0)
          this.usrbalance = this.transferCoin[0];
      });
    },
    onConfirm(item) {
      this.usrbalance = item;
      this.num = null;
      this.showPicker = false;
    },
    async toSearch() {
      await this.$http({
        method: "post",
        url: "searchUser",
        data: { username: this.searchval },
      }).then((res) => {
        this.usr = res.data;
      });
    },
    resetSearch() {
      this.ischeck = false;
      this.usr = null;
      this.num = null;
      this.pwd = null;
      this.searchval = null
    },
    async onSubmit() {
      if(this.posting)return
      this.posting = true
      const frm = {
        to_uid: this.usr.id,
        c_id: this.usrbalance.id,
        amount: this.num,
        paypassword: this.pwd,
      };
      await this.$http({
        method: "post",
        url: "balanceTransfer",
        data: frm,
      }).then((res) => {
          this.posting = false;
          this.$toast.success(res.msg);
         this.resetSearch()
          this.getTransferCoin()
        })
        .catch(() => {
          this.posting = false;
        });
    },
  },
};
</script>

<style>
</style>
